export const getTranslations = t => {
  return {
    recognitionCategory: category =>
      t("kf.visualsearch.label.recognitionCategory", { category }),
    recognitionCategorySubText: category =>
      t("kf.visualsearch.label.recognitionCategorySubText", { category }),
    faucetGuide: t("kf.visualsearch.label.faucetGuide"),
    toiletGuide: t("kf.visualsearch.label.toiletGuide"),
    volveGuide: t("kf.visualsearch.label.volveGuide"),
    sinkGuide: t("kf.visualsearch.label.sinkGuide"),
    defaultGuide: t("kf.visualsearch.label.defaultGuide"),
    commingSoon: t("kf.visualsearch.label.commingSoon"),
    viewGuidtext: t("kf.visualsearch.button.viewGuid"),
    backOnCategory: t("kf.visualsearch.button.backOnCategory"),
    errorText: t("kf.visualsearch.ErrorPage.errorText"),
    errorSubText: t("kf.visualsearch.ErrorPage.errorSubText"),
    tryAgainBtn: t("kf.visualsearch.ErrorPage.button.tryAgainBtn"),
    QRCodeText: t("kf.visualsearch.QRCode.text"),
    textCommingSoon: t("kf.visualsearch.label.textCommingSoon"),
    imageUploadtext: t("kf.visualsearch.ImageUpload.text"),
    borwseBtn: t("kf.visualsearch.ImageUpload.button.borwse"),
    changeProduct: t("kf.visualsearch.ImageUpload.text.changeProduct"),
    imageUploadSubText: t("kf.visualsearch.ImageUpload.subText"),
    photoGuidelineText: t("kf.visualsearch.ImageUpload.photoGuidelineText"),
    photoText: t("kf.visualsearch.ImageUpload.photoText"),
    wrongAngle: t("kf.visualsearch.ImageUpload.wrongAngle"),
    toClose: t("kf.visualsearch.ImageUpload.toClose"),
    toFar: t("kf.visualsearch.ImageUpload.toFar"),
    colorFinish: t("kf.pdp.label.colorOrFinish"),
    tooltip: t("kf.visualsearch.ImageCropper.toolTip"),
    toolTipCrop: t("kf.visualsearch.ImageCropper.toolTipCrop"),
    incorrectMatch: t("kf.visualsearch.label.textIncorrectMatch"),
    newSearch: t("kf.visualsearch.label.textNewSearch"),
    helpText: t("kf.visualsearch.label.textHelp"),
    feedbackText: t("kf.visualsearch.label.feedbackText"),
    closestMatch: t("kf.visualsearch.label.textClosestMatch"),
    partDiagramtext: t("kf.pdp.label.partsDiagram"),
    friendsFamilyPrice: t("kf.pdp.label.friendsFamilyPrice"),
    associatePrice: t("kf.pdp.label.associatePrice"),
    listPriceInfo: t("kf.pdp.label.listPriceInfo"),
    searchText: t("kf.visualsearch.page.search"),
    searchImageText: t("kf.visualsearch.page.searchImage"),
    serviewDetails: t("kf.technical.label.serviceParts"),
    toiletPhotoText: t("kf.visualsearch.ImageUpload.toilet.photoText"),
    sinkPhotoText: t("kf.visualsearch.ImageUpload.sink.photoText"),
    imageShould: t("kf.visualsearch.cameraGuide.imageShould"),
    servicePartInsrtuction1: t(
      "kf.visualsearch.cameraGuide.servicePartInsrtuction1"
    ),
    servicePartInsrtuction2: t(
      "kf.visualsearch.cameraGuide.servicePartInsrtuction2"
    ),
    servicePartInsrtuction3: t(
      "kf.visualsearch.cameraGuide.servicePartInsrtuction3"
    ),
    forFurtherHelp: t("kf.visualsearch.cameraGuide.forFurtherHelp"),
    contactSupport: t("kf.visualsearch.cameraGuide.contactSupportText"),
  }
}
